import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { listOrchards } from "@/lib/api";
import { TreePine, Search } from "lucide-react";

export default function AdminOrchards() {
  const { t } = useTranslation();
  const [items, setItems] = useState(null);
  const [filters, setFilters] = useState({ village: "", taluka: "", harvest_month: "", bahar: "" });

  const load = () => {
    const params = Object.fromEntries(Object.entries(filters).filter(([, v]) => v));
    listOrchards(params).then(setItems).catch(() => setItems([]));
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  return (
    <div data-testid="admin-orchards">
      <div className="flex items-center gap-3 mb-6">
        <TreePine className="w-6 h-6 text-[var(--tr-deep-green)]" />
        <h2 className="tr-section-title text-3xl">Orchards</h2>
      </div>

      <form onSubmit={(e) => { e.preventDefault(); load(); }} className="tr-card p-4 mb-6 grid grid-cols-1 md:grid-cols-5 gap-3 items-end">
        <label className="block">
          <span className="tr-label">Village</span>
          <input data-testid="o-filter-village" className="tr-input" value={filters.village} onChange={(e) => setFilters({ ...filters, village: e.target.value })} />
        </label>
        <label className="block">
          <span className="tr-label">Taluka</span>
          <input data-testid="o-filter-taluka" className="tr-input" value={filters.taluka} onChange={(e) => setFilters({ ...filters, taluka: e.target.value })} />
        </label>
        <label className="block">
          <span className="tr-label">Harvest month</span>
          <input data-testid="o-filter-harvest" className="tr-input" placeholder="e.g. September" value={filters.harvest_month} onChange={(e) => setFilters({ ...filters, harvest_month: e.target.value })} />
        </label>
        <label className="block">
          <span className="tr-label">Bahar</span>
          <input data-testid="o-filter-bahar" className="tr-input" placeholder="e.g. Ambia" value={filters.bahar} onChange={(e) => setFilters({ ...filters, bahar: e.target.value })} />
        </label>
        <button type="submit" data-testid="o-filter-apply" className="tr-pill-btn tr-btn-primary !min-h-[44px] !py-2 !px-4"><Search className="w-4 h-4" /> Apply</button>
        <div className="md:col-span-5 text-sm text-[var(--tr-muted)]">
          {items ? `${items.length} orchard${items.length === 1 ? "" : "s"}` : ""}
        </div>
      </form>

      {!items ? (
        <div className="p-8 text-[var(--tr-muted)]">{t("common.loading")}</div>
      ) : items.length === 0 ? (
        <div data-testid="admin-orchards-empty" className="tr-card p-10 text-center text-[var(--tr-muted)]">
          No orchards match these filters.
        </div>
      ) : (
        <div data-testid="admin-orchards-table" className="tr-card overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-[var(--tr-sage)]/50">
                <tr>
                  {["Orchard ID", "Farmer", "Village", "Taluka", "Area", "Trees", "Bahar", "Harvest", "Prod. (MT)"].map((h) => (
                    <th key={h} className="text-left px-4 py-3 font-semibold text-[var(--tr-deep-green)] uppercase text-[10px] tracking-[0.18em]">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {items.map((o) => (
                  <tr key={o.id} className="border-t border-[rgba(6,78,59,0.08)] hover:bg-[var(--tr-bone)]">
                    <td className="px-4 py-3 font-mono font-semibold text-[var(--tr-deep-green)]">{o.orchard_code}</td>
                    <td className="px-4 py-3">
                      <Link to={`/admin/farmer-profiles/${o.farmer_id}`} className="text-[var(--tr-deep-green)] font-semibold hover:underline">
                        {o.farmer_code}
                      </Link>
                    </td>
                    <td className="px-4 py-3">{o.location_village}</td>
                    <td className="px-4 py-3">{o.location_taluka || "—"}</td>
                    <td className="px-4 py-3">{o.area_raw || o.area_acres || "—"}</td>
                    <td className="px-4 py-3">{o.tree_count ?? "—"}</td>
                    <td className="px-4 py-3 text-xs">{o.bahar || "—"}</td>
                    <td className="px-4 py-3">{o.harvest_month || "—"}</td>
                    <td className="px-4 py-3">{o.expected_production_raw || o.expected_production_mt || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
